export default "__VITE_ASSET__BX7WaroK__"